import React from 'react';
import { ChevronDown, ChevronUp } from '@insurancemenu/imenu-components-lib/dist/icons';
import { Dropdown } from '@insurancemenu/imenu-components-lib';
import { DropdownPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import { ButtonStyled } from './styles';

interface Props extends DropdownPropsType {
  buttonTitle?: string;
  buttonDisabled?: boolean;
}

export const ActionsDropdown: React.FC<Props> = (props) => {
  return (
    <Dropdown
      {...props}
      closedElement={
        <ButtonStyled
          color="primary"
          type="text"
          uppercase
          rightIconProp={<ChevronDown />}
          size="small"
          disabled={props?.buttonDisabled}
        >
          {props?.buttonTitle || 'MORE'}
        </ButtonStyled>
      }
      openedElement={
        <ButtonStyled color="primary" rightIconProp={<ChevronUp />} size="medium" disabled={props?.buttonDisabled}>
          {props?.buttonTitle || 'MORE'}
        </ButtonStyled>
      }
    />
  );
};

export default ActionsDropdown;
